<template>
  <!-- 操作记录 -->
  <div class="box">
    <el-card class="mb5">
      <el-form label-position="top">
        <el-row
          :gutter="24" type="flex" justify="left"
          style="flex-wrap: wrap"
        >
          <el-col :span="6">
            <el-form-item>
              <template slot="label">
                <div class="searchNumberType">
                  <el-select v-model="numberType" size="small" @change="numTypeChange">
                    <!--扫描单号-->
                    <el-option :label="$t('placeOrder.scanOrderNumber')" :value="1" />
                    <!--安骏运单号-->
                    <el-option :label="$t('orderCenterCont.anjunWaybillNumber')" :value="2" />
                  </el-select>
                </div>
              </template>
              <el-input
                v-if="numberType === 1"
                v-model="queryForm.params.scanOrderNumber"
                :placeholder="$t('collectionCenter.max200Line')"
                :rows="1" type="textarea" clearable
                style="width: 100%"
                @blur="BlockNewline('scanOrderNumber')"
                @keydown.enter.native="BlockNewline('scanOrderNumber')"
              />
              <el-input
                v-if="numberType === 2"
                v-model="queryForm.params.waybillNumber"
                :placeholder="$t('collectionCenter.max200Line')"
                :rows="1" type="textarea" clearable
                style="width: 100%"
                @blur="BlockNewline('waybillNumber')"
                @keydown.enter.native="BlockNewline('waybillNumber')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 客户名称： -->
            <el-form-item :label="$t('collectionCenter.CustomerName')">
              <el-select
                v-model="queryForm.params.customerId"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable filterable multiple
                size="small" style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in customerIdList"
                  :key="index"
                  :label="item.username"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--操作网点-->
            <el-form-item :label="$t('collectionCenter.OperationSite')">
              <el-select
                v-model="queryForm.params.operateSiteId"
                :placeholder="$t('GlobalSetObj.Only10AreDisplayed')"
                clearable filterable multiple
                size="small" style="width: 100%"
                remote reserve-keyword :remote-method="remoteGetSiteList"
                @clear="remoteGetSiteList"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!--操作时间-->
            <el-form-item :label="$t('GlobalSetObj.operationTime')">
              <el-date-picker
                v-model="timeValue"
                :clearable="false"
                :default-time="['00:00:00', '23:59:59']"
                :placeholder="$t('newOrder.SelectDatetime')"
                range-separator="~"
                style="width: 100%"
                size="small"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="timeChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <div style="margin-bottom: 4px">
              <el-button
                size="mini"
                type="primary"
                @click="search"
              >{{ $t('newOrder.search') }} </el-button><!-- 搜索 -->
              <el-button
                size="mini"
                @click="reset"
              >{{ $t('collectionCenter.reset') }} </el-button><!-- 重置 -->
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <el-divider class="divider_class" />
    </el-card>
    <el-card>
      <el-button
        size="small" type="success" @click="chooseExport"
      >{{ $t('collectionCenter.export1') }} </el-button><!-- 勾选导出 -->
      <el-button
        size="small" type="success" @click="toExport"
      >{{ $t('collectionCenter.allExport') }} </el-button><!-- 全部导出 -->
      <el-table
        ref="tableRef"
        max-height="600" border
        :header-cell-style="{background: '#ebebeb', color: '#606266'}"
        style="width: 100%;margin-top: 20px"
        :data="tableData" @selection-change="handleSelectionChange"
      >
        <el-table-column align="center" type="selection" width="55" />
        <el-table-column :label="$t('operationCenter.ind')" width="60" align="center">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="scanOrderNumber"
          align="center"
          :label="$t('collectionCenter.ScanNumber')"
          min-width="130"
        /><!-- 扫描单号 -->
        <el-table-column
          prop="waybillNumber"
          align="center"
          :label="$t('orderCenterCont.anjunWaybillNumber')"
          min-width="150"
        /><!-- 安骏运单号 -->
        <el-table-column
          prop="customerName"
          align="center"
          :label="$t('collectionCenter.CustomerName')"
          min-width="130"
        /><!-- 客户名称 -->
        <el-table-column
          prop="supplementCollectTime"
          align="center"
          :label="$t('collectionCenter.supplementCollectionTime')"
          min-width="150"
        /><!-- 补充揽收时间 -->
        <el-table-column
          prop="operateTime"
          align="center"
          :label="$t('basicData.OperationTime')"
          min-width="200"
        /><!-- 操作时间 -->
        <el-table-column
          prop="operateSiteName"
          align="center"
          :label="$t('collectionCenter.OperationSite')"
          min-width="180"
        /><!-- 操作网点 -->
        <el-table-column
          prop="operateUserName"
          align="center"
          :label="$t('collectionCenter.controlsEmployee')"
          min-width="120"
        /><!-- 操作员 -->
        <el-table-column
          prop="operateNode"
          align="center"
          :label="$t('Resource.OperationNode')"
          min-width="130"
        /><!-- 操作节点 -->
      </el-table>
      <div class="right">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="currentPage"
          @size-change="sizePage"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryAllCustomer, siteFuzzyQuery, supplementLogs, supplementLogsExport } from '@/api/lanshou';
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList';
export default {
  name: 'SupplementCollectionLog',
  data() {
    return {
      numberType: 1,
      timeValue: [],
      customerIdList: [],
      siteList: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          operateStartTime: '',
          operateEndTime: '',
          scanOrderNumber: '',
          waybillNumber: '',
          operateSiteId: [],
          customerId: []
        }
      },
      total: 0,
      tableData: [],
      selectList: []
    };
  },
  created() {
    this.getCustomer();
    this.remoteGetSiteList('');
    this.reset();
    this.search();
  },
  methods: {
    BlockNewline(typeVal) {
      this.$nextTick(() => {
        if (this.queryForm.params[typeVal]) {
          let lines = this.queryForm.params[typeVal]
            .split('\n')
            .filter(line => line.trim() !== '')
            .map(line => line.replace(/\s+/g, ''));
          if (lines.length > 20000) {
            lines = lines.slice(0, 20000);
            this.$message.warning(this.$t('collectionCenter.intercept200'));
          }
          this.queryForm.params[typeVal] = lines.join('\n');
        }
      });
    },
    numTypeChange() {
      this.queryForm.params.scanOrderNumber = '';
      this.queryForm.params.waybillNumber = '';
    },
    timeChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.params.operateStartTime = '';
        this.queryForm.params.operateEndTime = '';
        return;
      }
      this.queryForm.params.operateStartTime = val[0];
      this.queryForm.params.operateEndTime = val[1];
    },
    reset() {
      const d = new Date();
      const today = dayjs(d).format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
      this.queryForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          operateStartTime: today + ' 00:00:00',
          operateEndTime: today + ' 23:59:59',
          scanOrderNumber: '',
          waybillNumber: '',
          operateSiteId: '',
          customerId: ''
        }
      };
    },
    currentPage() {
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      if (this.queryForm.params.scanOrderNumber) {
        queryForm.params.scanOrderNumber = queryForm.params.scanOrderNumber.split('\n');
      } else {
        queryForm.params.scanOrderNumber = [];
      }
      if (this.queryForm.params.waybillNumber) {
        queryForm.params.waybillNumber = queryForm.params.waybillNumber.split('\n');
      } else {
        queryForm.params.waybillNumber = [];
      }
      supplementLogs(queryForm).then(res => {
        if (res.code === 200) {
          this.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    sizePage() {
      this.queryForm.pageNumber = 1;
      this.currentPage();
    },
    search() {
      if ((!this.timeValue || this.timeValue.length < 0) &&
        !this.queryForm.params.scanOrderNumber &&
        !this.queryForm.params.waybillNumber
      ) {
        this.$message.error(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      this.sizePage();
    },
    getCustomer() {
      queryAllCustomer().then(res => {
        if (res.code === 200) {
          this.customerIdList = res.data.map(arr => {
            return {
              id: arr.id,
              username: arr.username
            };
          });
        }
      });
    },
    // 获取操作网点数据
    remoteGetSiteList(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    },
    toExport() {
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      if (this.queryForm.params.scanOrderNumber) {
        queryForm.params.scanOrderNumber = queryForm.params.scanOrderNumber.split('\n');
      } else {
        queryForm.params.scanOrderNumber = [];
      }
      if (this.queryForm.params.waybillNumber) {
        queryForm.params.waybillNumber = queryForm.params.waybillNumber.split('\n');
      } else {
        queryForm.params.waybillNumber = [];
      }
      supplementLogsExport(queryForm.params).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    handleSelectionChange(select) {
      this.selectList = select;
    },
    chooseExport() {
      if (!this.selectList.length) {
        this.$message.warning(this.$t('collectionCenter.checkMsg'));
        return;
      }
      const numList = this.selectList.map(item => {
        return item.waybillNumber;
      });
      const queryForm = {
        operateStartTime: '',
        operateEndTime: '',
        scanOrderNumber: [],
        waybillNumber: numList,
        operateSiteId: [],
        customerId: []
      };
      console.log(queryForm);
      supplementLogsExport(queryForm).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.box {
  padding: 20px;
  box-sizing: border-box;
}
.searchNumberType ::v-deep .el-select .el-input__inner {
  font-size: 14px;
  font-weight: 700;
  color: #606266;
}
.divider_class {
  height: 5px !important;
  background-color: #ebebeb !important;
}
</style>
